const SPRINGMAXPAGESIZE = 2000;
const VUETIFYMAXPAGESIZE = -1;

/**
 * Création d'un URLSearchParams avec un objet de pagination issue de @/plugins/paginated-table.js
 * @param {*} pagination
 * @returns
 */
export function pageParams(pagination) {
  const itemsPerPage = pagination.itemsPerPage;

  const params = new URLSearchParams();
  params.append("page", pagination.page - 1);
  params.append(
    "size",
    itemsPerPage === VUETIFYMAXPAGESIZE ? SPRINGMAXPAGESIZE : itemsPerPage
  );

  for (var i in pagination.sort) {
    const sort = pagination.sort[i];
    const direction = sort.asc ? "ASC" : "DESC";
    params.append("sort", `${sort.name},${direction}`);
  }
  return params;
}

/**
 * Permet de créer un objet URLSearchParams avec des parametres de recherche sous forme d'objet et de pagination
 * @param {*} search
 * @param {*} pagination
 */
export function searchPageParams(search, pagination) {
  const params = pageParams(pagination);

  for (const k of Object.keys(search)) {
    const v = search[k];
    if (v != null) {
      //exclusion des valeurs null
      if (Array.isArray(v)) {
        //boucle pour les tableaux
        v.forEach(e => params.append(k, e));
      } else {
        params.append(k, v);
      }
    }
  }
  return params;
}

/**
 * Extraction des données pour être conforme au store de @/plugins/paginated-table.js
 * @param {*} data
 * @returns
 */
export function extractPage(data) {
  const itemsPerPage = data.itemsPerPage;

  return {
    data: data.items,
    pagination: {
      page: data.page + 1,
      total: data.totalRows,
      itemsPerPage:
        itemsPerPage === SPRINGMAXPAGESIZE ? VUETIFYMAXPAGESIZE : itemsPerPage,
      sort: data.sort,
    },
  };
}
